import * as React from "react";
import { BellyBanner } from "../BellyBanner";
export const RibbonBanner = (props) => (React.createElement(BellyBanner, { title: props.title, items: [props.text], buttonText: props.buttonText, buttonUrl: props.buttonUrl }));
